//import { Injectable, OnInit, ComponentFactory, ComponentFactoryResolver } from '@angular/core';
//import { Observable } from 'rxjs';
//import { BehaviorSubject } from 'rxjs';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { v_EmployeeSearchBus } from '../models/v_EmployeeSearchBus';
import { KPIParameter } from '../models/KPIParameter';
import { DQOISearchParam } from '../models/DQOISearchParam';
import { BehaviorSubject } from 'rxjs';
import { GItem } from '../models/GItem';
import { DQOISearchEvent } from '../models/DQOISearchEvent';
import { SearchTarget } from '../enums/SearchTarget';
import { ToolbarEvent } from '../enums/ToolbarEvent';
import { DQOIToolbarEvent } from '../models/DQOIToolbarEvent';
import { DispatchesService } from './dispatches.service';

import { DashboardWidgetEvent } from '../models/DashboardWidgetEvent';

@Injectable({
    providedIn: 'root',
})
export class DashboardWidgetService extends BaseService {

    private _dashboardWidgetEvent: BehaviorSubject<any> = new BehaviorSubject(null);
    public dashboardWidgetEvent$: Observable<any> = this._dashboardWidgetEvent.asObservable();
    //private _dashboardWidgetEvent: BehaviorSubject<DashboardWidgetEvent> = new BehaviorSubject(null);
    //public dashboardWidgetEvent$: Observable<DashboardWidgetEvent> = this._dashboardWidgetEvent.asObservable();
    static count: number = 0;

    constructor(_http: HttpClient) {
        super(_http);
        this._dashboardWidgetEvent.next(null);
        DashboardWidgetService.count++;
    }

    nextDashboardWidgetEvent(e: DashboardWidgetEvent) {
        this._dashboardWidgetEvent.next(e);
    }

}
